import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby"
import WorkpageCard from "./WorkpageCard";
import FilterList from "../../../components/FilterList";
import { AnimatePresence, motion } from "framer-motion";
import BarLoader from "react-spinners/BarLoader";
import { useInView } from "react-intersection-observer";
import DynamicComponent from "../../../components/dynamicComponent";

const NoProjects = () => {
    return (
        <div className="text-center h-96 flex items-center justify-center flex-col">
            <h2 className="text-lg font-semibold">No projects found</h2>
            <p className="text-base">Try a different filter</p>
        </div>
    )
}

const AllWork = (props) => {


    const data = useStaticQuery(graphql`
    {
        posts: allStoryblokEntry(
            filter: {field_component: {eq: "work_page"}}
            sort: {first_published_at: DESC}
          ) {
            edges {
              node {
                id
                uuid
                name
                slug
                full_slug
                content
                created_at
                tag_list
              }
            }
          }
                filters: allStoryblokDatasourceEntry(
            filter: {parent: {}, data_source: {glob: "*-projects"}}
          ) {
            edges {
              node {
                id
                value
                name
                data_source
              }
            }
          }
        
      }
      
  `)


    const [workItems, setWorkItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const PAGE_SIZE = 12;
    const INJECT_TEXT_BLOCK_EVERY = 4;

    const cleanedFilters = data.filters.edges.map((filter) => {
        return {
            id: filter.node.value,
            title: filter.node.name,
            selected: false,
            col: filter.node.data_source
        }
    })

    const [filterCols, setFilterCols] = useState([
        "type-of-work-projects",
        "type-of-client-projects"
    ])

    
    const [filters, setFilters] = useState(cleanedFilters);

    // get first PAGE_SIZE items

    const firstItems = data.posts.edges.slice(0, PAGE_SIZE);

    const [visibleItems, setVisibleItems] = useState(firstItems);
    const [loadMoreVisible, setLoadMoreVisible] = useState(false);

    useEffect(() => {
        const selectedFilters = filters.filter((filter) => filter.selected);
        const filteredWorkItems = selectedFilters.length === 0
            ? data.posts.edges
            : data.posts.edges.filter((edge) => {
                const tagList = edge.node.tag_list;
                return selectedFilters.every((selectedFilter) => tagList.includes(selectedFilter.id));
            });
        setWorkItems(filteredWorkItems);
        setVisibleItems(filteredWorkItems.slice(0, PAGE_SIZE));
        setLoadMoreVisible(filteredWorkItems.length > PAGE_SIZE);
    }, [data, filters]);

    const loadMore = () => {
        setIsLoading(true);
        setVisibleItems((prevVisibleItems) => [
            ...prevVisibleItems,
            ...workItems.slice(prevVisibleItems.length, prevVisibleItems.length + PAGE_SIZE),
        ]);
        setLoadMoreVisible(visibleItems.length + PAGE_SIZE < workItems.length);
        setIsLoading(false);
    };

    const { ref, inView, entry } = useInView({
        /* Optional options */
        threshold: 0,
    });

    useEffect(() => {
        if (inView && loadMoreVisible && isLoading === false) {
            loadMore();
        }
    }, [inView]);

    const textBlocks = props.blok.text_blocks

    // if there is a tag param in the url, filter by that tag

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const tagParam = urlParams.get('tag');
        if (tagParam != undefined) {
            const tagFilter = filters.find((filter) => filter.id === tagParam);
            if (tagFilter != undefined) {
                tagFilter.selected = true;
                setFilters([...filters]);
            }
        }
    }, [])

    return (
        <section className="width pt-[6.5rem] lg:pt-32">

            <FilterList filters={filters} setFilters={setFilters} filterCols={filterCols} />


            {visibleItems && visibleItems.length > 0 ? (<AnimatePresence>

                <ol className="grid lg:grid-cols-2 gap-7 lg:gap-6">

                    {visibleItems.map((item, index) => {
                        const content = JSON.parse(item.node.content)
                        const canInject = index % INJECT_TEXT_BLOCK_EVERY === 0 && index !== 0;
                        let textBlockItem = undefined
                        if (canInject) {
                            const blokIndex = (index / INJECT_TEXT_BLOCK_EVERY) - 1;
                            const textBlock = textBlocks[blokIndex];
                            if (textBlock != undefined) {
                                textBlockItem = <DynamicComponent blok={textBlock} />
                            }

                        }

                        return (
                            <React.Fragment key={`work-item-${item.node.uuid}-fragment`}>

                                {canInject && textBlockItem != undefined && (
                                    <motion.li key={`work-item-${item.node.uuid}-text`} className="lg:col-span-2 work-block-inject">
                                        {textBlockItem}
                                    </motion.li >
                                )}

                                <motion.li key={`work-item-${item.node.uuid}`}
                                    layout
                                    initial={{ opacity: 0, scale: 0.8 }}
                                    animate={{ opacity: 1, scale: 1 }}
                                    exit={{ opacity: 0, scale: 0.8 }}
                                    transition={{ duration: 0.3 }}

                                >
                                    <WorkpageCard key={`work-item-${item.node.uuid}-card`} image={content.card_image} title={content.title} copy={content.tagline} url={item.node.full_slug} video={content.card_video} />
                                </motion.li>
                            </React.Fragment>
                        )
                    })}
                </ol>
            </AnimatePresence>
            ) : (<NoProjects />)
            }


            <div className="flex items-center justify-center text-center text-xl py-8 lg:py-9">
                {loadMoreVisible && <div ref={ref}>
                    <BarLoader color="#000" loading={true} />
                </div>}
            </div>

        </section >
    )
}

export default AllWork